export enum FileType {
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Pdf = 'application/pdf',
  Doc = 'application/msword',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Xls = 'application/vnd.ms-excel',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export enum FileExtension {
  Png = 'png',
  Jpg = 'jpg',
  Jpeg = 'jpeg',
  Pdf = 'pdf',
  Doc = 'doc',
  Docx = 'docx',
  Xls = 'xls',
  Xlsx = 'xlsx',
}

export enum HandlingFileError {
  EncryptedDocument = 'EncryptedDocument',
}
